import { React, useState } from "react";
import { Breadcrumb, Button, Col, Form, Input, List, Modal, Row } from "antd";
import { Link } from "react-router-dom"
import LogoWithoutText from "../../../../assets/images/logos/logo-metropolis-symbol.svg";
import { SVGicon } from "../../../../styleGuide/SVGicon/SVGicon";
import "./AppointmentEnterDetails.css";
import { Helmet } from "react-helmet";


/* eslint-disable no-template-curly-in-string */
const validateMessages = {
     required: "${label} is required!",
     types: {
          email: "${label} is not a valid email!",
          number: "${label} is not a valid number!",
     },
     number: {
          range: "${label} must be between ${min} and ${max}",
     }
};
/* eslint-enable no-template-curly-in-string */


export const AppointmentEnterDetails = () => {

     const [appoinmentConfirmedModal, setappoinmentConfirmedModal] = useState(false);


     const handleCustomWidthClose = () => {
          setappoinmentConfirmedModal(false);
     };


     const AppoinmentConfirmed = () => {
          return (

               /* Appoinment Confirmed Modal */
               <Modal
                    title="Custom Width"
                    open={appoinmentConfirmedModal}
                    closeIcon={SVGicon.mtpIconClose}
                    wrapClassName="mtp-modal"
                    width={720}
                    footer={""}
                    onCancel={handleCustomWidthClose}
                    centered
               >
                    <div className="appoinment-confirmed-modal-wrap">
                         <div className="appoinment-confirmed-modal-head flex-center">
                              <Link to="/" className="enhanced-profile-left-logo-wrap flex-center flex-auto-0 contain-image">
                                   < img src={LogoWithoutText} alt="footer-logo" />
                              </Link>
                              <h6 className="enhanced-profile-left-title fw-700">Confirmed</h6>
                              <p className=" fw-400">You are scheduled with Metropolis.</p>
                         </div>
                         <div className="appoinment-confirmed-modal-divider"></div>
                         <div className="appoinment-confirmed-modal-content">
                              <div className="appoinment-confirmed-modal-content-wrap">
                                   <Link to="/" className="enhanced-profile-left-logo-wrap flex-center flex-auto-0 contain-image">
                                        < img src={LogoWithoutText} alt="footer-logo" />
                                   </Link>
                                   <p className="fw-700">Metropolis Demo</p>
                              </div>
                              <List className="enhanced-profile-list">
                                   <List.Item className="enhanced-profile-list-item">
                                        <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                             {SVGicon.mtpIconCalendar}
                                        </span>
                                        <span>2:30pm - 3:00pm, Thursday, November 17, 2022</span>
                                   </List.Item>
                                   <List.Item className="enhanced-profile-list-item">
                                        <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                             {SVGicon.mtpIconMountainTime}
                                        </span>
                                        <span>Mountain Time - US & Canada</span>
                                   </List.Item>

                                   <List.Item className="enhanced-profile-list-item">
                                        <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                             {SVGicon.mtpIconLocation}
                                        </span>
                                        <span>A Metro Team Member will reach out and add a Zoom link to your
                                             calendar invite within 24 hours of your meeting.  </span>
                                   </List.Item>



                              </List>
                              <p className="invitation-text-wrap fw-600">A calendar invitation has been sent to your email address.</p>
                         </div>
                    </div>
               </Modal>

               /* Appoinment Confirmed Modal */
          );
     };


     return (
          <>
               <Helmet>
                    <title>AppointmentEnterDetails | Metropolis</title>
               </Helmet>
               <section className="appointment ground-color-ashes">
                    <div className="section-header-lg appointment-header-wrap">
                         <h2 className="section-header-lg-primary-heading  text-color-alpha fw-700">
                              Enter Details
                         </h2>
                         <p className="section-header-lg-secondary-text  text-color-bravo fw-400 mt-0">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                              incididunt ut
                         </p>
                    </div>
                    <div className="mtp-container">
                         <div className="appointment-wrap">
                              <div className="appointment-wrap-head-title d-flex align-center">
                                   <Breadcrumb separator=">">
                                        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                                        <Breadcrumb.Item href="">Get an Enhanced Profile</Breadcrumb.Item>
                                        <Breadcrumb.Item href="">Personal Details</Breadcrumb.Item>
                                   </Breadcrumb>
                              </div>
                              <div className="appointment-wrap-content-section">
                                   <div className="enhanced-profile-left-content">

                                        <Link to="/" className="enhanced-profile-left-logo-wrap flex-center flex-auto-0 contain-image">
                                             < img src={LogoWithoutText} alt="footer-logo" />
                                        </Link>
                                        <h6 className="enhanced-profile-left-title fw-600">Metropolis Demo</h6>
                                        <List className="enhanced-profile-list">
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconClock}
                                                  </span>
                                                  <span>30 Min</span>
                                             </List.Item>
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconLocation}
                                                  </span>
                                                  <span>A Metro Team Member will reach out and added
                                                       a zoom link to your calendar invite  </span>
                                             </List.Item>
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconCalendar}
                                                  </span>
                                                  <span>2:30pm - 3:00pm, Thursday, November 17, 2022</span>
                                             </List.Item>
                                             <List.Item className="enhanced-profile-list-item">
                                                  <span className="enhanced-profile-playIcon flex-center  flex-center-auto-0 contain-image">
                                                       {SVGicon.mtpIconMountainTime}
                                                  </span>
                                                  <span>Mountain Time - US & Canada</span>
                                             </List.Item>

                                        </List>

                                   </div>
                                   <div className="appointment-wrap-divider "></div>
                                   <div className="enhanced-profile-right-content">
                                        <div className="appointment-details-form-wrap">
                                             <Form layout="vertical" autoComplete="off" className="mtp-form" validateMessages={validateMessages}>
                                                  <Form.Item name="name" label="Name" rules={[{ required: true, message: "This field can not be empty!", }]} >
                                                       <Input className="mtp-form-control" placeholder="Ex. Karl Medriguez" />
                                                  </Form.Item>


                                                  <Row gutter={12}>
                                                       <Col span={12}>

                                                            <Form.Item name="email" label="Email" rules={[{ type: "email", required: true, }]} className="mb-0">
                                                                 <Input className="mtp-form-control" placeholder="Ex. www.xyz.com" />
                                                            </Form.Item>
                                                            <div className="add-guest-btn-wrap">
                                                                 <Button className="CustomButton add-guest-btn" type="prime-outlined" > Add Guests </Button>
                                                            </div>
                                                       </Col>
                                                       <Col span={12}>
                                                            <Form.Item name="company" label="Company" rules={[{ required: true }]}>
                                                                 <Input className="mtp-form-control" placeholder="Ex. ABC Company" />
                                                            </Form.Item>
                                                       </Col>
                                                  </Row>

                                                  <Form.Item name="shb-textarea-two" label="How did you hear about Metropolis?">
                                                       <Input.TextArea rows={3} className="mtp-form-control resize-none" placeholder="Ex. Lorem ipsum dolor sit" />
                                                  </Form.Item>

                                                  <Form.Item name="name" label="Send text messages to" className="mb-0">
                                                       <Input className="mtp-form-control" />
                                                  </Form.Item>
                                                  <p className="fw-400 text-mess-wrap">You will opt to next messages for this event. Message and date rates may apply.
                                                       Reply STOP to opt out.</p>

                                                  <div className=" schedule-event-wrap  flex-center">
                                                       <Button className="CustomButton" type="prime" onClick={() => setappoinmentConfirmedModal(true)} > Schedule Event </Button>
                                                  </div>
                                             </Form>

                                        </div>

                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
               <AppoinmentConfirmed />
          </>
     )
}